module.exports = __webpack_public_path__ + "static/img/bg.60445ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mother/bg.png
// module id = MrKu
// module chunks = 1